import { useEffect } from 'react';
import { useQuill } from '../editor/QuillContext';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { EditorActions } from '../editor/editorSlice';

const useTestHelpersInDev =
  process.env.NODE_ENV === 'production'
    ? () => {}
    : () => {
        const dispatch = useAppDispatch();
        const { quill } = useQuill();
        useEffect(() => {
          // @ts-expect-error
          window.quill = quill;
          // @ts-expect-error
          window.editorApi = {
            readOnly(value: boolean) {
              dispatch(EditorActions.readOnly(value));
            },
          };

          return () => {
            // @ts-expect-error
            delete window.quill;
            // @ts-expect-error
            delete window.editorApi;
          };
        }, [quill, dispatch]);
      };

export default useTestHelpersInDev;
